import React, { useState } from "react";
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from "firebase/auth";
import { auth } from "../../firebase";

export default function ChangePassword() {
  const user = auth.currentUser;

  const [currentPwd, setCurrentPwd] = useState("");
  const [newPwd1, setNewPwd1] = useState("");
  const [newPwd2, setNewPwd2] = useState("");

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [ok, setOk] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setOk("");

    if (!user) {
      setError("Vous devez être connecté pour changer votre mot de passe.");
      return;
    }

    if (!currentPwd) return setError("Veuillez entrer votre mot de passe actuel.");
    if (!newPwd1 || newPwd1.length < 6) return setError("Nouveau mot de passe trop court (min 6 caractères).");
    if (newPwd1 !== newPwd2) return setError("Les nouveaux mots de passe ne correspondent pas.");
    if (currentPwd === newPwd1) return setError("Le nouveau mot de passe doit être différent de l'ancien.");

    try {
      setSaving(true);

      // ✅ Re-auth obligatoire pour action sensible
      const credential = EmailAuthProvider.credential(user.email, currentPwd);
      await reauthenticateWithCredential(user, credential);

      // ✅ Update password
      await updatePassword(user, newPwd1);

      setOk("Mot de passe mis à jour ✅");
      setCurrentPwd("");
      setNewPwd1("");
      setNewPwd2("");
    } catch (e2) {
      console.error("ChangePassword error:", e2);
      const code = e2?.code || "";

      if (code === "auth/wrong-password" || code === "auth/invalid-credential") {
        setError("Mot de passe actuel incorrect.");
      } else if (code === "auth/too-many-requests") {
        setError("Trop de tentatives. Réessayez dans quelques minutes.");
      } else if (code === "auth/weak-password") {
        setError("Mot de passe trop faible.");
      } else if (code === "auth/requires-recent-login") {
        setError("Veuillez vous reconnecter puis réessayer.");
      } else {
        setError("Impossible de changer le mot de passe. Réessayez.");
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={styles.bg}>
      <div style={styles.card}>
        <h1 style={styles.h1}>Changer le mot de passe</h1>
        <p style={styles.p}>
          Entrez votre mot de passe actuel puis choisissez un nouveau mot de passe.
        </p>

        {!user && (
          <div style={styles.alertErr}>
            Vous n’êtes pas connecté. Connectez-vous pour accéder à cette page.
          </div>
        )}

        {error && <div style={styles.alertErr}>{error}</div>}
        {ok && <div style={styles.alertOk}>{ok}</div>}

        <form onSubmit={handleSubmit} style={{ marginTop: 12 }}>
          <label style={styles.label}>Mot de passe actuel</label>
          <input
            style={styles.input}
            type="password"
            value={currentPwd}
            onChange={(e) => setCurrentPwd(e.target.value)}
            placeholder="••••••••"
            disabled={!user || saving}
          />

          <label style={styles.label}>Nouveau mot de passe</label>
          <input
            style={styles.input}
            type="password"
            value={newPwd1}
            onChange={(e) => setNewPwd1(e.target.value)}
            placeholder="Min 6 caractères"
            disabled={!user || saving}
          />

          <label style={styles.label}>Confirmer le nouveau mot de passe</label>
          <input
            style={styles.input}
            type="password"
            value={newPwd2}
            onChange={(e) => setNewPwd2(e.target.value)}
            placeholder="Retapez le mot de passe"
            disabled={!user || saving}
          />

          <button type="submit" style={styles.btn} disabled={!user || saving}>
            {saving ? "Enregistrement…" : "Mettre à jour"}
          </button>

          <div style={styles.meta}>
            <a href="/vendor-dashboard" style={styles.link}>
              ← Retour au dashboard
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}

const styles = {
  bg: {
    minHeight: "100vh",
    background:
      "radial-gradient(900px 450px at 10% 0%, rgba(255,143,0,.18), transparent 60%), radial-gradient(700px 350px at 90% 0%, rgba(30,64,175,.18), transparent 55%), #f6f7fb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 14,
  },
  card: {
    width: "100%",
    maxWidth: 560,
    background: "#fff",
    borderRadius: 18,
    border: "1px solid rgba(15,23,42,.08)",
    boxShadow: "0 18px 45px rgba(0,0,0,.10)",
    padding: "18px 16px",
  },
  h1: { margin: 0, fontSize: 22, fontWeight: 900, color: "#0f172a" },
  p: { margin: "8px 0 0", color: "#475569", fontSize: 13, lineHeight: 1.6 },
  label: { display: "block", marginTop: 12, fontSize: 13, fontWeight: 900, color: "#0f172a" },
  input: {
    width: "100%",
    marginTop: 6,
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px solid rgba(15,23,42,.14)",
    outline: "none",
    fontSize: 14,
  },
  btn: {
    width: "100%",
    marginTop: 14,
    padding: "10px 12px",
    borderRadius: 999,
    border: 0,
    cursor: "pointer",
    fontWeight: 950,
    background: "linear-gradient(180deg, #ff9f1a, #ff8f00)",
    color: "#111827",
    boxShadow: "0 10px 22px rgba(255,143,0,.22)",
  },
  meta: { marginTop: 12, display: "flex", justifyContent: "space-between" },
  link: { color: "#1e40af", textDecoration: "none", fontWeight: 900, fontSize: 13 },
  alertErr: {
    marginTop: 12,
    background: "#fee2e2",
    color: "#b91c1c",
    borderRadius: 12,
    padding: "10px 12px",
    fontSize: 13,
    fontWeight: 800,
  },
  alertOk: {
    marginTop: 12,
    background: "#dcfce7",
    color: "#166534",
    borderRadius: 12,
    padding: "10px 12px",
    fontSize: 13,
    fontWeight: 800,
  },
};

